'use client';

import { THEME_OPTIONS } from 'utils/constants';
import { useTheme } from '../../contexts/ThemeContext';
import { useEffect, useState } from 'react';

interface LogoProps {
  width?: string;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ width = '120', className }) => {
  const { theme } = useTheme();
  const [logoFill, setLogoFill] = useState<string>('black');

  useEffect(() => {
    switch (theme) {
      case THEME_OPTIONS.lightMode:
      case THEME_OPTIONS.modernLightMode:
      case THEME_OPTIONS.paperLightMode:
        setLogoFill('black');
        break;
      case THEME_OPTIONS.darkMode:
      case THEME_OPTIONS.modernDarkMode:
      case THEME_OPTIONS.paperDarkMode:
      case THEME_OPTIONS.radarDarkMode:
      case THEME_OPTIONS.radarLightMode:
        setLogoFill('white');
        break;
      default:
        setLogoFill('black');
    }
  }, [theme]);

  return <LogoSVG fill={logoFill} width={width} className={className} />;
};

interface LogoSVGProps {
  fill?: string;
  className?: string;
  width?: string;
}

const LogoSVG: React.FC<LogoSVGProps> = ({ fill, className = 'inline', width = '120', ...props }) => {
  return (
    <svg
      className={className}
      width={width}
      viewBox="0 0 2381 592"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M143.655 471.28C216.938 471.28 267.411 420.807 267.411 345.582C267.411 270.357 216.938 219.884 143.655 219.884C70.8567 219.884 20.3834 270.357 20.3834 345.582C20.3834 420.807 70.8567 471.28 143.655 471.28ZM80.0777 345.582C80.0777 301.903 105.314 272.299 143.655 272.299C181.995 272.299 207.717 301.903 207.717 345.582C207.717 389.261 181.995 418.865 143.655 418.865C105.314 418.865 80.0777 389.261 80.0777 345.582ZM322.639 551.358H380.392V440.705C394.952 460.117 421.159 471.28 451.734 471.28C519.193 471.28 565.299 420.807 565.299 345.582C565.299 270.357 519.193 219.884 451.734 219.884C417.762 219.884 388.642 232.988 373.597 255.313V227.164H322.639V551.358ZM379.421 345.582C379.421 301.903 404.658 272.299 442.513 272.299C479.882 272.299 505.604 301.903 505.604 345.582C505.604 389.261 479.882 418.865 442.513 418.865C404.658 418.865 379.421 389.261 379.421 345.582ZM725.083 471.28C782.836 471.28 819.235 441.19 833.794 395.085H774.585C766.82 412.071 750.319 422.748 725.568 422.748C688.684 422.748 665.874 401.394 662.962 365.48H836.706C837.677 355.774 837.677 348.009 837.677 340.729C837.677 266.475 793.998 219.884 722.171 219.884C653.741 219.884 606.179 268.416 606.179 344.126C606.179 420.807 653.255 471.28 725.083 471.28ZM662.962 320.831C664.903 288.314 687.228 266.475 722.171 266.475C759.055 266.475 779.438 288.314 779.438 319.375V320.831H662.962ZM890.425 464H948.178V328.596C948.178 294.623 969.047 272.299 1000.59 272.299C1031.17 272.299 1048.64 289.77 1048.64 326.655V464H1106.39V320.831C1106.39 256.769 1070.48 219.884 1012.24 219.884C982.15 219.884 955.458 231.532 941.383 254.827V227.164H890.425V464ZM1196.33 191.736V227.164H1135.66V278.123H1196.33V464H1254.08V278.123H1330.28V227.164H1254.08V198.045C1254.08 182.029 1263.3 175.235 1278.35 175.235H1344.84V124.276H1265.24C1222.05 124.276 1196.33 148.057 1196.33 191.736ZM1460.73 471.28C1488.4 471.28 1514.12 461.088 1529.65 441.19V464H1580.61V227.164H1522.85V362.568C1522.85 397.026 1502.96 418.865 1471.89 418.865C1441.8 418.865 1425.3 401.394 1425.3 364.509V227.164H1367.55V370.333C1367.55 434.396 1402.98 471.28 1460.73 471.28ZM1647.79 464H1705.54V328.596C1705.54 294.623 1726.41 272.299 1757.96 272.299C1788.53 272.299 1806 289.77 1806 326.655V464H1863.76V320.831C1863.76 256.769 1827.84 219.884 1769.6 219.884C1739.51 219.884 1712.82 231.532 1698.75 254.827V227.164H1647.79V464ZM2028.78 471.28C2062.27 471.28 2091.39 458.176 2106.43 435.851V464H2157.39V124.276H2099.64V250.459C2085.08 231.047 2058.87 219.884 2028.78 219.884C1960.84 219.884 1915.22 270.357 1915.22 345.582C1915.22 420.807 1960.84 471.28 2028.78 471.28ZM1974.91 345.582C1974.91 301.903 2000.15 272.299 2038 272.299C2075.37 272.299 2100.61 301.903 2100.61 345.582C2100.61 389.261 2075.37 418.865 2038 418.865C2000.15 418.865 1974.91 389.261 1974.91 345.582Z"
        fill={fill}
      />
      <rect x="1307" y="227" width="80" height="51" fill={fill} />
    </svg>
  );
};
